import { ReactNode } from 'react'
import PersonComponent from './Person'
import PersonList from './PersonList'

export interface PersonProps {
  name?: string
  email?: string
  image?: string
  small?: boolean
  style?: any
  extra?: ReactNode
  onClick?: () => void
  includeExtraInInfo?: boolean
}

const Person: any = PersonComponent
Person.List = PersonList

export default Person
